import dateFormat from 'dateformat'

export default {
  /**
   * DateFormat
   * Document  https://www.npmjs.com/package/dateformat
   */
  dateFormat: (value, format = 'yyyy-mm-dd hh:MM') => {
    return dateFormat(value, format)
  },
  toFixed: (value, length = 2) => {
    try {
      value = parseFloat(value)
    } catch (error) {
      value = 0
    }
    return value.toFixed(length) * 1
  },
  secondFormat: (value) => {
    let _mins = Math.floor(value / 60)
    // let mins = _mins < 10 ? ('0'+_mins ) : _mins
    let _second = value % 60
    if (_mins == 0 && _second < 10) {
      return value
    }
    let second = _second < 10 ? ('0' + _second) : _second

    return `${_mins}:${second}`
  }
}
